const bridge = () =>
  typeof window !== "undefined" ? window.desktopOfflinePriceLists : null;

const cleanError = (error) => {
  const message = String(error?.message || error || "Offline price-list operation failed.")
    .replace(/^Error invoking remote method '[^']+':\s*(?:Error:\s*)?/i, "")
    .replace(/^Error:\s*/i, "")
    .trim();
  return new Error(message || "Offline price-list operation failed.");
};

export const offlinePriceListRequest = async (path, payload = {}) => {
  const api = bridge();
  if (!api) throw new Error("Restart the desktop app to initialize offline price lists.");
  const methods = {
    list: "list",
    save: "save",
    delete: "remove",
    catalog: "catalog",
    "items/save": "saveItems",
    prices: "prices",
  };
  const method = methods[path];
  if (!method || typeof api[method] !== "function") {
    throw new Error("Unsupported offline price-list operation.");
  }
  try {
    return await api[method](payload);
  } catch (error) {
    throw cleanError(error);
  }
};
